import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx } from "vue";
import { computed } from "vue";
import { Document } from "@ceereals/vue-pdf";
import CoverPage from "./CoverPage.vue";
import ServicePage from "./ServicePage.vue";
import { translatePdf } from "./pdf-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItineraryDocument',
    props: {
        projection: {}
    },
    setup(__props) {
        const props = __props;
        const itinerary = computed(() => props.projection.itinerary);
        const services = computed(() => itinerary.value.slots_itineraries ?? []);
        const itineraryCode = computed(() => itinerary.value.code || "ITN-0000");
        const brandName = computed(() => props.projection.brand?.name ||
            props.projection.concierge?.company_name ||
            props.projection.concierge?.assigned_person ||
            props.projection.concierge?.name ||
            "Emanta");
        const author = computed(() => props.projection.brand?.creator ||
            props.projection.brand?.name ||
            brandName.value);
        const documentTitle = computed(() => props.projection.brand?.documentTitle ||
            translatePdf(props.projection.locale, "pdf.cover.default_title"));
        const producer = computed(() => props.projection.brand?.producer || author.value);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Document), {
                title: `${documentTitle.value} ${itineraryCode.value}`,
                author: author.value,
                subject: documentTitle.value,
                keywords: `itinerary, travel, tourism, ${brandName.value}`,
                creator: author.value,
                producer: producer.value
            }, {
                default: _withCtx(() => [
                    _createVNode(CoverPage, { projection: __props.projection }, null, 8, ["projection"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (item, index) => {
                        return (_openBlock(), _createBlock(ServicePage, {
                            key: item.id ?? index,
                            item: item,
                            index: index,
                            "total-services": services.value.length,
                            "itinerary-code": itineraryCode.value,
                            theme: __props.projection.theme,
                            locale: __props.projection.locale
                        }, null, 8, ["item", "index", "total-services", "itinerary-code", "theme", "locale"]));
                    }), 128))
                ]),
                _: 1
            }, 8, ["title", "author", "subject", "keywords", "creator", "producer"]));
        };
    }
});
